module.exports = __webpack_public_path__ + "static/media/slider-5.85f28bff.jpg";